import api from '../utils/axios';
import { DEV_FETCH_EMBED_TOKEN_AND_URL } from '../utils/Constants';

const getPowerBIEmbeddedConfig = (body) => api.post(DEV_FETCH_EMBED_TOKEN_AND_URL, body, {}, {});

const PowerBIService = {
  getPowerBIEmbeddedConfig,
};
export default PowerBIService;
